import { render, staticRenderFns } from "./orderTransactionTable.vue?vue&type=template&id=6fc7a2d1&scoped=true&"
import script from "./orderTransactionTable.vue?vue&type=script&lang=js&"
export * from "./orderTransactionTable.vue?vue&type=script&lang=js&"
import style0 from "./orderTransactionTable.vue?vue&type=style&index=0&id=6fc7a2d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc7a2d1",
  null
  
)

export default component.exports